// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5c8cac3"};